import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { ISetPasswordDto } from "./types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  ISetPasswordDto
>("stores.setPassword");

export const setPassword = {
  ...postApis,
};
